import { ShowRoomStream } from "src/types/common";

export const selectors = {
  getShowRoomStreams: (state: ShowRoomStream[]) => state,
};
